// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"5daed80a","166":"31c90305","182":"ada6189b","453":"f5011043","537":"b13a2539","781":"104315bd"}[chunkId] + ".chunk.js";
};